import { getCompanies } from 'controllers'
import { AUTOCOMPLETE_PAGESIZE, Junction } from 'localConstants'

export default function getCompaniesAutocompleteBase(search: string, statuses: string[]) {
  return getCompanies({
    junction: Junction.AND,
    order: 'asc',
    orderBy: 'name',
    page: 0,
    pageSize: AUTOCOMPLETE_PAGESIZE,
    search,
    statuses
  })
}
